export default {"src":"/_next/static/media/CASH.de46ad05.svg","height":18,"width":18};